import React, { useEffect, useState } from "react"
import { CustomHeader } from "../../components/headers/CustomHeader"
import {
  Button,
  Card,
  CardBody,
  Input,
  Spinner,
  Tooltip,
  Typography,
} from "@material-tailwind/react"
import Papa from "papaparse"

import moment from "moment"
import { toast } from "react-toastify"
import { DEFAULTPRIMARYCOLOR } from "../../util"

import { DetailDrawer } from "../../components"

import InvestToInsureDetail from "../../components/Details/invest-2-insure-detail"
import { FiDownloadCloud } from "react-icons/fi"
import { useSelector } from "react-redux"
import { RootState } from "../../store/store"
import { RiAdminLine } from "react-icons/ri"
import { DriverAggreateType } from "../../types/query"
import {
  DRIVERAGGREGATE,
  GETINVESTTOINSUREPOLICIES,
} from "../../GraphQl/queries"
import { useQuery, useLazyQuery } from "@apollo/client"
// import { useSearch } from "../../hooks/useSearch"
import { getColorCode } from "../../colorCodes"
import PerPageAndPagination from "../../components/paginations/perpageAndPagination"
import { DocumentNode } from "graphql";
import dayjs from "dayjs";



interface BusinessClassByBusinessClass {
  id: string
  name: string
}
interface SubClass {
  id: string
  name: string
}
interface Request {
  registration_number_text: string
  policyholder: {
    first_name: string
    last_name: string
    id: string
  }
  start_date: string
  end_date: string
  premium_amount: string
  businessClassByBusinessClass: BusinessClassByBusinessClass
  sub_class: SubClass
}
interface Policy {
  policy_number: string
  request: Request
}

interface ResponseType {
  id: string;
  policy_number: string;
  datecreated: string;
  registration_number_text: string;
  premium_amount: string;
  start_date: string;
  end_date: string;
  policyholder_id: string;
  policyholder_first_name: string;
  policyholder_last_name: string;
  business_class_id: string;
  business_class_name: string;
  sub_class_id: string;
  sub_class_name: string;
  total_paid: string;
  outstanding_premium: string;
  driver_id: string;
  driver_name: string;
  nationality: string;
  weekly_income_range: string;
  driver_license_number: string;
  driver_gender: string;
  payment_status: string;
  driver_code: string;
  driver_phone: string;
  sub_agent_id?: string | null;
  sub_agent_first_name?: string | null;
  sub_agent_last_name?: string | null;
  sub_agent_phone?: string | null;
  company_staff_id?: string | null;
  company_staff_name?: string | null;
  company_staff_phone?: string | null;
  driver_balance: string
  agent_branch_name: string
  agent_division_name: string
  staff_branch_name: string
  staff_division_name: string

}

const Invest2InsurePayments = () => {
  const [searchText, setSearchText] = useState("")
  const [data, setData] = useState<ResponseType[]>([])


  // const MIN_DATE = dayjs("2025-01-01T00:00");
  // const MAX_DATE = dayjs("2025-12-31T23:59");

  // // Start with "now"
  // let end = dayjs();

  // // Clamp END to max allowed date
  // if (end.isAfter(MAX_DATE)) {
  //   end = MAX_DATE;
  // }

  // // Derive START as 1 month before END
  // let start = end.subtract(1, "month");

  // // Clamp START to min allowed date
  // if (start.isBefore(MIN_DATE)) {
  //   start = MIN_DATE;
  // }

  // Final defaults
  // const defaultStart = start.format("YYYY-MM-DDTHH:mm");
  // const defaultEnd = end.format("YYYY-MM-DDTHH:mm");


  const [selectedRow, setSelectedRow] = useState<ResponseType>()
  const [open, setOpen] = useState<boolean>(false)
  // const [paginatedData, setPaginatedData] = useState<ResponseType[] | [] | undefined>([])
  const [totalPageSize, setTotalPageSize] = useState(0)

  // New updates



  const defaultStart = moment().subtract(1, "month").format("YYYY-MM-DDTHH:mm");
  const defaultEnd = moment().format("YYYY-MM-DDTHH:mm");
  const [startDate, setStartDate] = useState(defaultStart);
  const [endDate, setEndDate] = useState(defaultEnd);
  const [tempStartDate, setTempStartDate] = useState(defaultStart);
  const [tempEndDate, setTempEndDate] = useState(defaultEnd);
  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const [searchFilterStart, setSearchFilterStart] = useState("");
  const [searchFilterEnd, setSearchFilterEnd] = useState("");
  const [searchData, setSearchData] = useState<ResponseType[] | undefined>(undefined)




  const {
    companyId,
    user: stateUser,
    token,
  } = useSelector((state: RootState) => state.auth)

  const { data: totalPolicies, loading: load } =
    useQuery<DriverAggreateType>(DRIVERAGGREGATE)



  const handleStartDateChange = (event: any) => {
    const value = event.target.value
    const formattedValue = value + ":00Z" // Append seconds and 'Z' for timezone
    setStartDate(formattedValue)
    setActivePage(1)
    setSearchText("")
  }

  const handleEndDateChange = (event: any) => {
    const value = event.target.value
    const formattedValue = value + ":00Z" // Append seconds and 'Z' for timezone
    setEndDate(formattedValue)
  }

  const handleTempStartDateChange = (event: any) => {
    const value = event.target.value
    if (value) {
      const dateOnly = value.split("T")[0]; // Extract just the date part
      const formattedValue = `${dateOnly}T00:00`; // Set time to 12:00 AM
      setTempStartDate(formattedValue);
    }
  }

  const handleTempEndDateChange = (event: any) => {
    const value = event.target.value
    if (value) {
      const formattedValue = value
      setTempEndDate(formattedValue)
    }
  }

  const handleDateChange = () => {
    const start = dayjs(tempStartDate);
    const end = dayjs(tempEndDate);
    const diffInMonths = end.diff(start, 'month', true);

    setIsFilterLoading(true);

    if (searchData !== undefined) {
      setSearchFilterStart(tempStartDate)
      setSearchFilterEnd(tempEndDate)
      setIsFilterLoading(false);
    } else {
      if (diffInMonths > 13) {
        setTempStartDate(defaultStart);
        setTempEndDate(defaultEnd);
        toast.error("Date range cannot exceed 13 months.");
        setIsFilterLoading(false);
        return;
      }

      setTimeout(() => {
        fetchData({
          variables: {
            start_date: tempStartDate,
            end_date: tempEndDate
          }
        });
        setIsFilterLoading(false);
      }, 1000);
    }
  };

  // const handleTempStartDateChange = (event: any) => {
  //   const value = event.target.value;
  //   if (!value) return;

  //   const dateOnly = value.split("T")[0];
  //   let selected = dayjs(`${dateOnly}T00:00`);

  //   if (selected.isBefore(MIN_DATE)) {
  //     selected = MIN_DATE;
  //     toast.error("Start date cannot be before 1st January 2025");
  //   }

  //   if (selected.isAfter(MAX_DATE)) {
  //     selected = MAX_DATE;
  //     toast.error("Start date cannot be after 31st December 2025");
  //   }

  //   if (tempEndDate && selected.isAfter(dayjs(tempEndDate))) {
  //     toast.error("Start date cannot be after end date");
  //     return;
  //   }

  //   setTempStartDate(selected.format("YYYY-MM-DDTHH:mm"));
  // };

  // const handleTempEndDateChange = (event: any) => {
  //   const value = event.target.value;
  //   if (!value) return;

  //   let selected = dayjs(value);

  //   if (selected.isBefore(MIN_DATE)) {
  //     selected = MIN_DATE;
  //     toast.error("End date cannot be before 1st January 2025");
  //   }

  //   if (selected.isAfter(MAX_DATE)) {
  //     selected = MAX_DATE;
  //     toast.error("End date cannot be after 31st December 2025");
  //   }

  //   if (tempStartDate && selected.isBefore(dayjs(tempStartDate))) {
  //     toast.error("End date cannot be before start date");
  //     return;
  //   }

  //   setTempEndDate(selected.format("YYYY-MM-DDTHH:mm"));
  // };

  // const handleDateChange = () => {
  //   const start = dayjs(tempStartDate);
  //   const end = dayjs(tempEndDate);

  //   if (end.isBefore(start)) {
  //     toast.error("End date cannot be before start date");
  //     return;
  //   }

  //   const diffInMonths = end.diff(start, "month", true);

  //   if (diffInMonths > 3) {
  //     toast.error("Date range cannot exceed 3 months.");
  //     return;
  //   }

  //   setIsFilterLoading(true);

  //   fetchData({
  //     variables: {
  //       start_date: tempStartDate,
  //       end_date: tempEndDate
  //     }
  //   });

  //   setTimeout(() => setIsFilterLoading(false), 1000);
  // };




  const reset = () => {
    setStartDate(defaultStart);
    setEndDate(defaultEnd);
    setTempStartDate(defaultStart);
    setTempEndDate(defaultEnd);
    setSearchFilterStart("");
    setSearchFilterEnd("");
    if (searchData === undefined) {
      fetchData({
        variables: {
          start_date: defaultStart,
          end_date: defaultEnd
        }
      });
    }
  }

  const handleSearch = () => {
    search()
  }



  // const useSearch = (
  //   query: DocumentNode,
  //   searchText: string,
  //   extraVariables: Record<string, any> = {}
  // ) => {
  //   const { data, loading, error } = useQuery(query, {
  //     variables: {
  //       search: searchText,
  //       ...extraVariables,
  //     },
  //   });

  //   return { data, loading, error };
  // };

  // const { loading: loadingData, data: investData } = useSearch(
  //   GETINVESTTOINSUREPOLICIES,
  //   searchText,
  //   { startDate, endDate }
  // );

  const [fetchData, { loading: loadingData, data: investData }] = useLazyQuery(GETINVESTTOINSUREPOLICIES, {
  })

  // console.log(investData)

  useEffect(() => {
    fetchData({
      variables: {
        start_date: defaultStart,
        end_date: defaultEnd
      }
    });
  }, [companyId]);


  const search = async () => {
    if (searchText) {
      try {
        setIsFilterLoading(true)
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/search-invest2insure-policies?search_term=${searchText}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        )

        const req = await response.json()

        if (response.ok) {
          console.log(req)
          setSearchData(req.data)
          toast.success(req?.message)
        } else {
          // setSearchData("")
          toast.error(req?.message)
        }
        setIsFilterLoading(false)
      } catch (error) {
        // setSearchData("")
        toast.error("Could not perform search")
        setIsFilterLoading(false)
      }
    }
  }





  const filterData = (item: ResponseType) => {
    const text = searchText?.toLowerCase() || "";

    const fullName = `${item?.policyholder_first_name ?? ""} ${item?.policyholder_last_name ?? ""}`.toLowerCase();
    const businessClass = item?.business_class_name?.toLowerCase() ?? "";
    const policyNumber = item?.policy_number?.toLowerCase() ?? "";
    const subClass = item?.sub_class_name?.toString().toLowerCase() ?? "";
    const regNum = item?.registration_number_text?.toString().toLowerCase() ?? "";
    const premiumAmount = item?.premium_amount?.toString().toLowerCase() ?? "";
    const totalPaid = item?.total_paid?.toString().toLowerCase() ?? "";
    const outstanding = item?.outstanding_premium?.toLowerCase() ?? "";
    const paymentStatus = item?.payment_status?.toLowerCase() ?? "";
    const startDate = item?.start_date?.toLowerCase() ?? "";
    const endDate = item?.end_date?.toLowerCase() ?? "";
    const driverName = item?.driver_name?.toLowerCase() ?? "";
    const createdDate = item?.datecreated?.toLowerCase() ?? "";

    const agentName = item?.company_staff_name
      ? item.company_staff_name
      : `${item?.sub_agent_first_name ?? ""} ${item?.sub_agent_last_name ?? ""}`;
    const agentPhone = item?.company_staff_phone ?? item?.sub_agent_phone ?? "";
    const agentType = item?.company_staff_name ? "Company Staff" : "Sub Agent";
    const branchName = item?.company_staff_name ? item?.staff_branch_name : item?.agent_division_name ?? "";
    const divisionName = item?.company_staff_name ? item?.staff_division_name : item?.agent_division_name ?? "";

    return (
      fullName.includes(text) ||
      businessClass.includes(text) ||
      policyNumber.includes(text) ||
      subClass.includes(text) ||
      regNum.includes(text) ||
      premiumAmount.includes(text) ||
      totalPaid.includes(text) ||
      outstanding.includes(text) ||
      paymentStatus.includes(text) ||
      startDate.includes(text) ||
      endDate.includes(text) ||
      driverName.includes(text) ||
      agentName.toLowerCase().includes(text) ||
      agentPhone.toLowerCase().includes(text) ||
      agentType.toLowerCase().includes(text) ||
      branchName.toLowerCase().includes(text) ||
      divisionName.toLowerCase().includes(text) ||
      createdDate.includes(text)
    );
  };

  function filterDate(item: ResponseType): boolean {
    const date = new Date(item?.datecreated);
    const start = new Date(searchFilterStart);
    const end = new Date(searchFilterEnd);

    return date >= start && date <= end;
  }

  const [activePage, setActivePage] = useState(0)
  const [pageSize, setPageSize] = useState(10)

  useEffect(() => {
    if (searchText || startDate || endDate || pageSize) {
      setActivePage(0)

    }
  }, [searchText, startDate, endDate, pageSize])
  useEffect(() => {
    if (pageSize) {
      setActivePage(0)
      // setSearchText("")
      setStartDate("")
      setEndDate("")
    }
  }, [pageSize])

  const displayData = searchData !== undefined ? searchData : investData?.policy

  const totalItems = (searchFilterStart || searchFilterEnd) ? displayData?.filter(filterDate) : displayData

  const endOffset = activePage + pageSize
  const paginatedData = totalItems?.slice(activePage, endOffset)



  const handleDownload = () => {
    // Check if there is data to download
    if (paginatedData?.length === 0) {
      alert("No data to download.")
      return
    }

    if (searchText || startDate || endDate) {
      const type = totalItems?.map((item: ResponseType) => ({
        "policy number": item?.policy_number,
        "business class": item?.business_class_name,
        "sub class": item?.sub_class_name,
        "vehicle reg number": item?.registration_number_text,
        "premium amount": item?.premium_amount,
        "outstanding amount": item?.outstanding_premium,
        "total paid": item?.total_paid,
        branch: item?.company_staff_name ? item?.staff_branch_name : item?.agent_branch_name,
        division: item?.company_staff_name ? item?.staff_division_name : item?.agent_division_name,
        "policy date created": moment(item?.datecreated).format("LLL"),
        "policy start date": moment(item?.start_date).format("LLL"),
        "policy end date": moment(item?.end_date).format("LLL"),
        "driver name": item?.driver_name,
        "driver code": item?.driver_code,
        "wallet balance": item?.driver_balance,
        "driver phone":
          item?.driver_phone,
        "driver nationality": item?.nationality,
        "driver income range": item?.weekly_income_range,
        "driver license number": item?.driver_license_number,
        "staff name": item?.company_staff_name,
        "staff number":
          item?.company_staff_phone
      }))
      const firstItem = type![0]
      const originalHeaders = Object.keys(firstItem!)
      const upperHeaders = originalHeaders.map((h) => h.toUpperCase())
      // Transform data to match headers (Simplified)
      const transformedData = type?.map((item: any) => {
        const transformedItem: Record<string, string> = {};
        originalHeaders.forEach((originalKey, idx) => {
          const upperKey = upperHeaders[idx];
          transformedItem[upperKey] = String(item[originalKey as keyof typeof item]);
        });
        return transformedItem;
      });
      // Convert data to CSV format
      const csvData = Papa.unparse({
        fields: upperHeaders,
        data: transformedData!,
      })

      // Create a Blob and download link
      const blob = new Blob([csvData], { type: "text/csv" })
      const url = window.URL.createObjectURL(blob)
      // Create a download link
      const a = document.createElement("a")
      a.href = url
      a.download = `${"invest-2-insure-policies"}.csv`
      document.body.appendChild(a)
      // Trigger a click on the link to start the download
      a.click()
      // Cleanup
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
      return
    }
    const type = investData?.policy?.map((item: ResponseType) => ({
      "policy number": item?.policy_number,
      "business class": item?.business_class_name,
      "sub class": item?.sub_class_name,
      "vehicle reg number": item?.registration_number_text,
      "premium amount": item?.premium_amount,
      "outstanding amount": item?.outstanding_premium,
      "total paid": item?.total_paid,
      branch: item?.company_staff_name ? item?.staff_branch_name : item?.agent_branch_name,
      division: item?.company_staff_name ? item?.staff_division_name : item?.agent_division_name,
      "policy date created": moment(item?.datecreated).format("LLL"),
      "policy start date": moment(item?.start_date).format("LLL"),
      "policy end date": moment(item?.end_date).format("LLL"),
      "driver name": item?.driver_name,
      "wallet balance": item?.driver_balance,
      "driver code": item?.driver_code,
      "driver phone":
        item?.driver_phone,
      "driver nationality": item?.nationality,
      "driver income range": item?.weekly_income_range,
      "driver license number": item?.driver_license_number,
      "staff name": item?.company_staff_name,
      "staff number":
        item?.company_staff_phone
    }))
    const firstItem = type![0]
    const originalHeaders = Object.keys(firstItem!)
    const upperHeaders = originalHeaders.map((h) => h.toUpperCase())
    // Transform data to match headers (Simplified)
    const transformedData = type?.map((item: any) => {
      const transformedItem: Record<string, string> = {};
      originalHeaders.forEach((originalKey, idx) => {
        const upperKey = upperHeaders[idx];
        transformedItem[upperKey] = String(item[originalKey as keyof typeof item]);
      });
      return transformedItem;
    });
    // Convert data to CSV format
    const csvData = Papa.unparse({
      fields: upperHeaders,
      data: transformedData!,
    })

    // Create a Blob and download link
    const blob = new Blob([csvData], { type: "text/csv" })
    const url = window.URL.createObjectURL(blob)
    // Create a download link
    const a = document.createElement("a")
    a.href = url
    a.download = `${"invest-2-insure-policies"}.csv`
    document.body.appendChild(a)
    // Trigger a click on the link to start the download
    a.click()
    // Cleanup
    window.URL.revokeObjectURL(url)
    document.body.removeChild(a)
  }

  //--------------------------

  const userData = stateUser
  const [colors, setColors] = useState<string[]>()

  useEffect(() => {
    if (userData) {
      // const data: UserType = JSON.parse(userData)

      const colors = getColorCode(stateUser?.colors)

      setColors(colors)
    }
  }, [stateUser?.colors, userData])

  return (
    <>
      <CustomHeader title="Invest-2-Insure Policies" />
      <DetailDrawer
        title="Payment Detail"
        open={open}
        size={400}
        onClose={() => setOpen(false)}
        children={<InvestToInsureDetail content={selectedRow} />}
      />
      <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-2 md:lg:gap-4 lg:gap-5">
        <Card className="bg-brand-info rounded-lg rounded-tr-[40px] rounded-bl-[50px] shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
          <div className="flex flex-row justify-between">
            <div>
              <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                {load ? (
                  <Spinner className="mb-2 text-white" />
                ) : (
                  totalItems?.length
                  // totalPolicies?.total_drivers_policies?.aggregate?.count
                )}
              </Typography>
              <Typography className="text-sm uppercase font-normal text-white">
                total drivers policies
              </Typography>
            </div>
            <RiAdminLine size={28} color="#cbcbcb" />
          </div>

        </Card>
      </div>
      <div className="mt-10">
        <CardBody className="shadow-sm sticky px-0 py-0  rounded-3xl w-full">
          <div className="bg-black pt-5 rounded-t-2xl">
            <Typography
              variant="h6"
              style={{
                color:
                  colors?.length! > 1
                    ? `${colors![0]?.toLowerCase()}`
                    : `${DEFAULTPRIMARYCOLOR}`,
              }}
              className="px-4 pb-4  font-bold leading-none opacity-70 capitalize"
            >
              List of Policies{" "}
              <span className=" text-white">
                {totalItems?.length}
              </span>
            </Typography>
          </div>

          <div className="w-full">
            <div className="flex flex-col  gap-y-4  bg-white px-3 py-4">
              <div className="flex shrink-0 flex-col justify-end gap-2 sm:flex-row">
                <Tooltip content="Export as CSV">
                  <Button
                    onClick={handleDownload}
                    variant="filled"
                    className="capitalize text-sm font-normal flex flex-wrap gap-2"
                    size="sm"
                  >
                    <FiDownloadCloud size={20} />
                    <span>Download csv</span>
                  </Button>
                </Tooltip>
              </div>
              <div className="p-3 flex gap-x-2 items-center flex-col 2xl:flex-row gap-y-3 mb-5">
                <div className="w-full flex flex-row gap-x-2">
                  <Input
                    crossOrigin="anonymous"
                    label="Search"
                    value={searchText}
                    onChange={(e) => {
                      setSearchText(e.target.value)
                      if (e.target.value === "") {
                        setSearchText("")
                        setSearchData(undefined)
                        setSearchFilterStart("")
                        setSearchFilterEnd("")
                      }
                    }}
                    icon={<i className="fas fa-search text-base"></i>}
                  />
                  <Button
                    onClick={handleSearch}
                    variant="filled"
                    className="capitalize text-sm font-normal flex flex-wrap items-center justify-center"
                    size="sm"
                  >
                    <span>Search</span>
                  </Button>
                </div>
                <div className="flex flex-col xl:flex-row gap-3 justify-between mb-0">
                  <div className="flex items-center space-x-2">
                    <label className="font-semibold text-gray-700">From</label>
                    <Input
                      type="datetime-local"
                      value={tempStartDate} // Remove 'Z' for input value
                      onChange={handleTempStartDateChange}
                      size="md"
                      className="!border-t-blue-gray-200 focus:!border-t-gray-900 w-full"
                      labelProps={{
                        className: "before:content-none after:content-none",
                      }}
                    />
                  </div>
                  <div className="flex items-center space-x-2">
                    <label className="font-semibold text-gray-700">To</label>
                    <Input
                      type="datetime-local"
                      value={tempEndDate} // Remove 'Z' for input value
                      onChange={handleTempEndDateChange}
                      size="md"
                      className="!border-t-blue-gray-200 focus:!border-t-gray-900 w-full"
                      labelProps={{
                        className: "before:content-none after:content-none",
                      }}
                    />
                  </div>
                  <div className="flex shrink-0 flex-col gap-4 justify-end sm:flex-row">
                    <Tooltip content="Apply Date filters">
                      <Button
                        onClick={handleDateChange}
                        variant="filled"
                        className="capitalize text-sm font-normal flex flex-wrap align-middle"
                        size="sm"
                      >
                        <span>Filter</span>
                      </Button>
                    </Tooltip>
                    <Tooltip content="Clear All Date filters">
                      <Button
                        onClick={reset}
                        variant="filled"
                        className="capitalize text-sm bg-red-400 font-normal flex flex-wrap"
                        size="sm"
                      >
                        <span>Clear</span>
                      </Button>
                    </Tooltip>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <CardBody className="px-0 py-0">
            <div
              className="overflow-x-auto overflow-y-auto"
              style={{ maxHeight: "65vh" }}
            >
              <table className="w-full bg-white min-w-max table-auto">
                <thead className="bg-white sticky z-50 top-0">
                  <tr>
                    {[
                      "policy holder",
                      "policy number",
                      "Business Class",
                      "Sub Class",
                      "Vehicle Reg. No.",
                      "Premium amount",
                      "Premium Paid",
                      "Outstanding Premium",
                      "Payment status",
                      "Policy Start Date",
                      "Policy Expiry Date",
                      "driver's name",
                      "driver nationality",
                      "driver income range",
                      "driver license number",
                      "wallet balance",
                      "staff/Agent",
                      "Policy Created Date",
                    ].map((head) => (
                      <th
                        key={head}
                        className=" border-y border-blue-gray-100 text-black bg-gray-50/50 p-4  text-center"
                      >
                        <Typography
                          color="black"
                          className="font-bold text-sm text-black leading-none opacity-70 capitalize"
                        >
                          {head}
                        </Typography>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {paginatedData?.map((item: any, index: number) => {
                    const isLast = index === paginatedData?.length - 1
                    const classes = isLast
                      ? "px-2 py-3  text-center"
                      : "px-2 py-3 border-b-2 border-blue-gray-50 text-center"

                    return (
                      <tr
                        onClick={() => {
                          setSelectedRow(item)
                          setOpen(true)
                        }}
                        key={index.toString()}
                        className="hover:bg-gray-100 transition-all hover:cursor-pointer"
                      >
                        {/* <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize "
                          >
                            {item?.transaction_id}
                          </Typography>
                        </td> */}
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {item?.policyholder_first_name +
                              " " +
                              item?.policyholder_last_name}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {item?.policy_number}
                          </Typography>
                        </td>

                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {item?.business_class_name}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {item?.sub_class_name}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {item?.registration_number_text}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            GHS
                            {parseFloat(
                              item?.premium_amount ?? "0"
                            ).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            GHS
                            {parseFloat(
                              item?.total_paid ?? "0"
                            ).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            GHS
                            {parseFloat(
                              item?.outstanding_premium ?? "0"
                            ).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {item?.payment_status}

                          </Typography>
                        </td>

                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {moment(item?.start_date).format("LLL")}
                          </Typography>
                        </td>

                        {/* <td className={classes}>
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal text-xs capitalize"
                      >
                        GHS
                        {(item?.amount ?? 0).toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </Typography>
                    </td> */}

                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {moment(item?.end_date).format("LLL")}
                          </Typography>
                        </td>

                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {
                              item?.driver_name
                            }
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {
                              item?.nationality ?? "N/A"
                            }
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {
                              item?.weekly_income_range || "N/A"
                            }
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {
                              item?.driver_license_number || "N/A"
                            }
                          </Typography>
                        </td>

                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >

                            GHS
                            {parseFloat(
                              item?.driver_balance ?? "0"
                            ).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}

                          </Typography>
                        </td>

                        <td className={classes}>
                          <div className="flex flex-col gap-2 text-left">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize "
                            >
                              Full name:{" "}
                              <span className="font-normal">
                                {item?.company_staff_name
                                  ? item.company_staff_name
                                  : `${item?.sub_agent_first_name} ${item?.sub_agent_last_name}`}
                              </span>

                            </Typography>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize "
                            >
                              Phone number:{" "}
                              <span className="font-normal">
                                {item?.company_staff_phone ? item.company_staff_phone : item?.sub_agent_phone}
                              </span>
                            </Typography>

                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize "
                            >
                              User type:{" "}
                              <span className="font-normal">
                                {item?.company_staff_name ? "Company Staff" : "Sub Agent"}
                              </span>
                            </Typography>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize "
                            >
                              Branch:{" "}
                              <span className="font-normal">
                                {item?.company_staff_name ? item.staff_branch_name : item?.agent_division_name}
                              </span>
                            </Typography>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize "
                            >
                              Division:{" "}
                              <span className="font-normal">
                                {item?.company_staff_name ? item.staff_division_name : item?.agent_division_name}
                              </span>
                            </Typography>
                          </div>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {moment(item?.datecreated).format("LLL")}
                          </Typography>
                        </td>

                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </CardBody>
          {(loadingData || isFilterLoading) && (
            <div className="mt-10 flex items-center justify-center">
              <Spinner className="w-10 h-10" />
            </div>
          )}

          {!paginatedData && (!loadingData) && (
            <div className="mt-10 flex items-center justify-center">
              <Typography color="white" variant="h6">
                No data found
              </Typography>
            </div>
          )}

          {paginatedData?.length! < 1 && (!loadingData) && (
            <div className="mt-10 flex items-center justify-center">
              <Typography color="white" variant="h6">
                No data found
              </Typography>
            </div>
          )}
        </CardBody>

        {
          // <GeneralPagination
          //   totalItems={
          //     searchText || startDate || endDate
          //       ? lengthOfItems
          //       : totalPageSize! ?? 0
          //   }
          //   itemsPerPage={pageSize}
          //   currentPage={activePage}
          //   onPageChange={handlePageChange}
          // />

          <PerPageAndPagination
            customColor="white"
            total={
              totalItems?.length
            }
            currentPage={activePage}
            setCurrentPage={setActivePage}
            perPage={pageSize}
            setPerPage={setPageSize}
          />
        }
      </div>
    </>
  )
}

export default Invest2InsurePayments
